import { render, staticRenderFns } from "./competitionPointBlackUserList.vue?vue&type=template&id=5430d2ae&scoped=true"
import script from "./competitionPointBlackUserList.vue?vue&type=script&lang=ts"
export * from "./competitionPointBlackUserList.vue?vue&type=script&lang=ts"
import style0 from "./competitionPointBlackUserList.vue?vue&type=style&index=0&id=5430d2ae&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5430d2ae",
  null
  
)

export default component.exports